var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-row",
        { staticClass: "mr-2 ml-2" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Marca",
                  rules: [
                    _vm.rules.required(),
                    _vm.rules.fieldLength(50),
                    _vm.rules.specialCharacters()
                  ]
                },
                model: {
                  value: _vm.accessCar.brand,
                  callback: function($$v) {
                    _vm.$set(_vm.accessCar, "brand", $$v)
                  },
                  expression: "accessCar.brand"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Modelo",
                  rules: [
                    _vm.rules.required(),
                    _vm.rules.fieldLength(50),
                    _vm.rules.specialCharacters()
                  ]
                },
                model: {
                  value: _vm.accessCar.model,
                  callback: function($$v) {
                    _vm.$set(_vm.accessCar, "model", $$v)
                  },
                  expression: "accessCar.model"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Placa",
                  hint: "Solo números y letras",
                  rules: [
                    _vm.rules.required(),
                    _vm.rules.fieldLength(10),
                    _vm.rules.validatePlate(),
                    _vm.rules.isDuplicated(_vm.numberPlateForValidation)
                  ]
                },
                on: { change: _vm.emitNumberPlate },
                model: {
                  value: _vm.accessCar.numberPlate,
                  callback: function($$v) {
                    _vm.$set(_vm.accessCar, "numberPlate", $$v)
                  },
                  expression: "accessCar.numberPlate"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }